import React from 'react';
import { Dialog } from '@mui/material';
import { DeleteOutlined, WarningAmberRounded } from '@mui/icons-material';
import { DebugPanel } from '../DebugPanel';
import { ConfirmSheet, TITLE_ID } from './parts';
import { BuildScreen, CelebrateScreen, ReviewScreen, StartScreen, SuccessScreen } from './screens';
import { SmartGoalDialogProps, useSmartGoalDialogController } from './useSmartGoalDialogController';

const screens = {
  start: StartScreen,
  celebrate: CelebrateScreen,
  build: BuildScreen,
  review: ReviewScreen,
  success: SuccessScreen,
};

export const SmartGoalDialog: React.FC<SmartGoalDialogProps> = (props) => {
  const goalFlow = useSmartGoalDialogController(props);

  // Past week 12 the cohort's exercise period has ended — no goal setting.
  if (props.weekNumberIndexZero > 12) {
    return null;
  }

  const Screen = screens[goalFlow.screen];

  return (
    <Dialog
      open={props.open}
      fullScreen
      onClose={goalFlow.requestClose}
      aria-labelledby={TITLE_ID}
      data-testid="smart-goal-dialog"
    >
      <Screen goalFlow={goalFlow} />
      <DebugPanel displayItem={goalFlow.state} />
      <ConfirmSheet
        open={goalFlow.deleteConfirmOpen}
        icon={<DeleteOutlined />}
        title="Remove activity?"
        confirmLabel="Yes, remove it"
        cancelLabel="Keep it"
        onConfirm={goalFlow.confirmDelete}
        onCancel={goalFlow.cancelDelete}
      >
        Are you sure you want to remove <strong>{goalFlow.deleteTargetName}</strong> from your goal?
      </ConfirmSheet>
      <ConfirmSheet
        open={goalFlow.leaveWarningOpen}
        icon={<WarningAmberRounded />}
        title="Start over?"
        confirmLabel="Yes, start over"
        cancelLabel="Keep editing"
        onConfirm={goalFlow.confirmLeave}
        onCancel={goalFlow.cancelLeave}
      >
        Leaving now will clear your progress. You&apos;ll need to start over and choose your activities again.
      </ConfirmSheet>
    </Dialog>
  );
};
